import { Button } from 'foundations-components/transitional/components/Button';
import { H6 } from 'foundations-components/transitional/components/H6';
import { H4 } from 'foundations-components/transitional/components/H4';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Tile, TileSection } from 'foundations-components/transitional/components/Tile';
import ApprovalRequestAccessModal from '../requestAccessModal/ApprovalRequestAccessModal';
import { useState } from 'react';
import ApprovalNotEnabledStep from './ApprovalNotEnabledStep';
import { trackInteraction } from '../../utils/usageTracker';
import * as trackingConstants from '../../constants/trackingConstants';
import { useApprovalContext } from '../../hooks/useApprovalContext';
import { ApprovalRequestAccessHeadingI18n, ApprovalRequestAccessDescriptionI18n, ApprovalRequestAccessStepTwoI18n, ApprovalRequestAccessStepThreeI18n } from '../i18n/ApprovalRequestAccessI18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import useApprovalConditions from '../../hooks/useApprovalConditions';
import PortalIdParser from 'PortalIdParser';
import { View } from 'foundations-components/transitional/components/View';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { ApprovalsIcon, SendIcon, PublishIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ApprovalNotEnabled() {
  const [showRequestAccessModal, setShowRequestAccessModal] = useState(false);
  const {
    meta
  } = useApprovalContext();
  const {
    isSuperAdmin
  } = useApprovalConditions();
  const portalId = PortalIdParser.get();
  const setupApprovalUrl = meta.approvalType === 'QUOTE' ? `/settings/${portalId}/sales/quotes` : `/settings/${portalId}/approvals`;
  const closeRequestAccessModal = () => {
    setShowRequestAccessModal(false);
  };
  const openRequestAccessModal = () => {
    setShowRequestAccessModal(true);
    trackInteraction(trackingConstants.APPROVAL_REQUEST_ACCESS_MODAL_OPENED, meta.approvalType);
  };
  const handleAdminGoToSettingsTracking = () => {
    trackInteraction(trackingConstants.APPROVAL_REQUEST_ACCESS_ADMIN_GO_TO_SETTINGS_BUTTON, meta.approvalType);
  };
  return /*#__PURE__*/_jsxs(TFlex, {
    direction: "column",
    alignItems: "center",
    padding: "500",
    "data-test-id": "product-approvals-approval-sidebar-not-enabled",
    children: [/*#__PURE__*/_jsx(TFlex, {
      justify: "center",
      marginBlockEnd: "900",
      children: /*#__PURE__*/_jsx(Illustration, {
        name: "approvals",
        width: 150
      })
    }), /*#__PURE__*/_jsxs(TFlex, {
      direction: "column",
      marginBlockEnd: "300",
      textAlign: "center",
      children: [/*#__PURE__*/_jsx(H4, {
        children: /*#__PURE__*/_jsx(ApprovalRequestAccessHeadingI18n, {
          approvalType: meta.approvalType
        })
      }), /*#__PURE__*/_jsx(Paragraph, {
        children: /*#__PURE__*/_jsx(ApprovalRequestAccessDescriptionI18n, {
          approvalType: meta.approvalType
        })
      })]
    }), /*#__PURE__*/_jsx(Tile, {
      compact: true,
      children: /*#__PURE__*/_jsxs(TileSection, {
        children: [/*#__PURE__*/_jsx(H6, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "productApprovals.ApprovalRequestAccess.steps.heading"
          })
        }), /*#__PURE__*/_jsxs(View, {
          marginBlockEnd: "300",
          as: "div",
          children: [/*#__PURE__*/_jsx(ApprovalNotEnabledStep, {
            icon: SendIcon,
            text: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "productApprovals.ApprovalRequestAccess.steps.stepOne"
            })
          }), /*#__PURE__*/_jsx(ApprovalNotEnabledStep, {
            icon: ApprovalsIcon,
            text: /*#__PURE__*/_jsx(ApprovalRequestAccessStepTwoI18n, {
              approvalType: meta.approvalType
            })
          }), /*#__PURE__*/_jsx(ApprovalNotEnabledStep, {
            icon: PublishIcon,
            text: /*#__PURE__*/_jsx(ApprovalRequestAccessStepThreeI18n, {
              approvalType: meta.approvalType
            })
          })]
        })]
      })
    }), isSuperAdmin ? /*#__PURE__*/_jsx(Button, {
      "data-test-id": "product-approvals-sidebar-button-go-to-settings",
      use: "tertiary",
      href: setupApprovalUrl,
      onClick: handleAdminGoToSettingsTracking,
      marginBlockStart: "500",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalRequestAccess.requestAccessButtonAdmin"
      })
    }) : /*#__PURE__*/_jsx(Button, {
      "data-test-id": "product-approvals-sidebar-button-request-access",
      use: "tertiary",
      onClick: openRequestAccessModal,
      marginBlockStart: "500",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalRequestAccess.requestAccessButtonRequester"
      })
    }), showRequestAccessModal && /*#__PURE__*/_jsx(ApprovalRequestAccessModal, {
      closeRequestAccessModal: closeRequestAccessModal
    })]
  });
}
export default ApprovalNotEnabled;